import { TextArea } from "pepsico-ds";

const CustomRichTextEditor = (props) => {
  const { value, updateValue, label, required, placeholder, enabled } = props;

  return (
    <div className="display-flex my-1 flex-direction-column gap-2">
      <TextArea
        style={{
          maxHeight: "200px",
          overflowY: "auto",
          maxWidth: "100%",
          pointerEvents: !enabled ? "auto" : undefined,
        }}
        label={label}
        required={required}
        placeholder={placeholder}
        value={value}
        onUpdate={updateValue}
        showToolbar={true}
        disabled={!enabled}
      />
    </div>
  );
};

export default CustomRichTextEditor;
